import React from "react";
import {NewEntitySearch} from "../../reorganize/entity-search/new-entity-search";

export function FolderSelect({value='',meta,current_folder='',onChange,onBlur}) {

    return <NewEntitySearch placeholder='Search for a folder' context={meta} is_multi={false} searchable={{folders:true}} excluded={{folders:{[current_folder]:true}}} onChange={(val)=>onChange(val.value)} value={{value,type:'folders'}} />;
}